import type { TransformedSectionName } from '@/lib/apollo/query/getActivitiesForUser/dataTransformations/types'

export const toSectionNameLabel = (sectionName?: TransformedSectionName): string => {
  if (sectionName === undefined) {
    return 'Unknown'
  }

  return sectionName.charAt(0).toUpperCase() + sectionName.slice(1)
}
